import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { WebSocketProvider } from './context/WebSocketContext';
import { AlphalendWebSocketProvider } from './context/AlphalendWebSocketContext';
import { StsuiWebSocketProvider } from './context/StsuiWebSocketContext';
import { Tracker } from './utils/tracker';
import App from './App';
import './index.css';
import 'ui-kit/dist/main.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DAppKitProvider } from '@mysten/dapp-kit-react';
import { dAppKit } from './utils/dappKit';
import { NetworkProvider } from './context/NetworkContext';
import { BalanceProvider } from './context/BalanceContext';
import { PositionProvider } from './context/PositionContext';
import { AdminAddressProvider } from './context/AdminAddressContext';
import { applyLazerProxyOverride } from './utils/rpcEndpoints';
Tracker.init();
Tracker.startTransactionListener();
// Before any transaction is built, so price updates use the configured proxy. Mainnet
// only — the other networks' constants already name a proxy that allows a dev-server
// origin, so switching network at runtime needs nothing further.
applyLazerProxyOverride();
const queryClient = new QueryClient();
const root = createRoot(document.getElementById('root'));
root.render(_jsx(QueryClientProvider, { client: queryClient, children: _jsx(DAppKitProvider, { dAppKit: dAppKit, children: _jsx(AdminAddressProvider, { children: _jsx(WebSocketProvider, { children: _jsx(AlphalendWebSocketProvider, { children: _jsx(StsuiWebSocketProvider, { children: _jsx(NetworkProvider, { children: _jsx(BalanceProvider, { children: _jsx(PositionProvider, { children: _jsx(App, {}) }) }) }) }) }) }) }) }) }));
